module.exports = __webpack_public_path__ + "img/optionBg.b050b484.png";